export const team: Record<number, string> = {
  0: "NONE",
  1: "US",
  2: "RU",
  3: "US",
  4: "RU",
  5: "US",
  6: "RU",
  7: "US",
  8: "RU"
}